import { render, staticRenderFns } from "./DialogPolitica.vue?vue&type=template&id=1845c6ed&"
import script from "./DialogPolitica.vue?vue&type=script&lang=js&"
export * from "./DialogPolitica.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports